export const root = '/plugins/storage';
export const BASE_URL = process.env.REACT_APP_API_ROOT_DEFAULT + root + '/';

export const api = {
    storage_documents_details: BASE_URL + 'documents/:id/',
    storage_file: BASE_URL + 'files/',
};
